import {
  AutoSaveNoteDto,
  AutoSaveNoteQueryDto,
  UpdateAutoSaveNoteDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const autoSaveNotesRequests = {
  getAutoSavedNote: EndpointDefinition.get<
    AutoSaveNoteDto,
    AutoSaveNoteQueryDto
  >({
    name: 'getAutoSavedNote',
    route: '/notes/auto-save',
  }),

  postAutoSavedNote: EndpointDefinition.post<
    AutoSaveNoteDto,
    UpdateAutoSaveNoteDto,
    AutoSaveNoteQueryDto
  >({
    name: 'postAutoSavedNote',
    route: '/notes/auto-save',
  }),

  deleteAutoSavedNote: EndpointDefinition.delete<null, AutoSaveNoteQueryDto>({
    name: 'deleteAutoSavedNote',
    route: '/notes/auto-save',
  }),
};
